import { isScrumEnvironment } from '@/settings/environment.utils';

export const SEGMENT_FLAG_OVERRIDE_KEY = 'p_segment_flag_override';

export function allowSegmentFlagOverride () {
    return isScrumEnvironment() && !window.Cypress;
}

export function useSegmentFlagOverride () {
    if (!allowSegmentFlagOverride()) {
        return false;
    }

    try {
        const override = localStorage.getItem(SEGMENT_FLAG_OVERRIDE_KEY);

        return !!JSON.parse(override);
    } catch (error) {
        console.error(error);

        return false;
    }
}

export function setSegmentFlagOverride (override) {
    if (!allowSegmentFlagOverride()) {
        deleteSegmentFlagOverride();

        return;
    }

    localStorage.setItem(SEGMENT_FLAG_OVERRIDE_KEY, JSON.stringify(override));
}

function deleteSegmentFlagOverride () {
    if (localStorage.getItem(SEGMENT_FLAG_OVERRIDE_KEY) !== null) {
        localStorage.removeItem(SEGMENT_FLAG_OVERRIDE_KEY);
    }
}
